import { length, map } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { keyFigure } from '../../partials/key-figure';

export const keyFigureSlice = ({ primary }) => {
  const normalized = keyFigure(primary);
  if (normalized) {
    return clear({
      type: CommonSliceType.KEY_FIGURE,
      keyFigures: [normalized],
    });
  }
};

export const keyFigure3Slice = ({ items = [] }) => {
  const normalized = map(keyFigure, items);

  if (length(normalized)) {
    return {
      type: CommonSliceType.KEY_FIGURE,
      keyFigures: normalized,
    };
  }
};
